import { WrapperProps } from "../types/wrapper.type";
import "./TaplinkWrap.css";

export const TaplinkWrap = ({ children }: WrapperProps): JSX.Element => {
  return <section className="taplink">{children}</section>;
};
